import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import useSpinnerControl from 'hooks/Meteorology/Fields/ModelPerformance/useSpinnerControl';

export default function MapSpinnerControl({ isLoading }: { isLoading: boolean }) {
  const map = useMap();
  const spinnerControl = useSpinnerControl(isLoading);

  useEffect(() => {
    if (!map || !spinnerControl) return () => {};

    map.addControl(spinnerControl);
    return () => { map.removeControl(spinnerControl); };
  }, [map, spinnerControl]);

  return null;
}
